import type { ApplicationBridge } from '@app/services/ApplicationBridge'

import { createThunk } from '@app/store/thunk'

export function getApplicationBridge() {
  return createThunk((_dispatch, _getState, context) => context.lookup<ApplicationBridge>(ApplicationBridgeSymbol))
}
export function setApplicationBridge(value: ApplicationBridge) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ApplicationBridgeSymbol, value))
}

const ApplicationBridgeSymbol = Symbol('ApplicationBridge')
